import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, IconButton, InputBase } from "@mui/material";
import {
  ModalContainer,
  Header,
  SearchBox,
  ChipsWrapper,
  BodyWrapper,
  SectionTitle,
  ListWrapper,
  ListItem,
} from "./SearchModalStyled";
import { recentSearches, recentFiles, searchResults } from "./dummyData";
import { CloseIcon } from "../../../assets/icons";
import FilterChips from "../../../components/FilterChips";

const SearchModal = ({ open, onClose }) => {
  const [query, setQuery] = useState("");

  const handleChange = (e) => setQuery(e.target.value);

  const chipOptions = [
    { key: "all", label: "All", countKey: "all" },
    { key: "matters", label: "Matters", countKey: "matters" },
    { key: "folders", label: "Folders", countKey: "folders" },
    { key: "files", label: "Files", countKey: "files" },
  ];

  const counts = {
    all: 23,
    matters: 20,
    folders: 1,
    files: 2,
  };

  const [activeChip, setActiveChip] = useState("all");

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContainer>
        {/* Header */}
        <Header>
          <SearchBox>
            {/* <Search/> */}
            <InputBase
              placeholder="Search Matter/ folder/ file here"
              value={query}
              onChange={handleChange}
              fullWidth
            />
          </SearchBox>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Header>

        {/* Filter Chips Placeholder */}
        <ChipsWrapper>
          <FilterChips
            options={chipOptions}
            activeKey={activeChip}
            counts={counts}
            onChange={setActiveChip}
          />
        </ChipsWrapper>

        {/* Body */}
        <BodyWrapper>
          {query.trim() === "" ? (
            <>
              {/* Recent Searches */}
              <SectionTitle>Recent Searches</SectionTitle>
              <ListWrapper>
                {recentSearches.map((item) => (
                  <ListItem key={item?.id}>{item}</ListItem>
                ))}
              </ListWrapper>

              {/* Recently Opened Files */}
              <SectionTitle>Recently Opened Files</SectionTitle>
              <ListWrapper>
                {recentFiles.map((file) => (
                  <ListItem key={file?.id}>{file}</ListItem>
                ))}
              </ListWrapper>
            </>
          ) : (
            <>
              {/* Search Results */}
              <SectionTitle>Search Results</SectionTitle>
              <ListWrapper>
                {searchResults.map((result) => (
                  <ListItem key={result?.id}>{result}</ListItem>
                ))}
              </ListWrapper>
            </>
          )}
        </BodyWrapper>
      </ModalContainer>
    </Modal>
  );
};

SearchModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SearchModal;
